<template>
	<div id="menu-w" class="menu-w menu-has-selected-link menu-activated-on-hover color-style-default  menu-position-side menu-side-left menu-side-left menu-layout-compact"
	:class="(w >= 1200) ? 'sub-menu-style-over' : 'sub-menu-style-inside'">
		<div class="logo-w">
			<router-link :to="{name: 'Dashboard'}" class="logo"><img src="static/assets/img/logo.png"></router-link>
		</div>
		<dock />
		<onlineUsers />
	</div>
</template>

<script>
    import Dock from './dock'
    import ProfilePic from '@/components/user/ProfilePic'
    import onlineUsers from '@/components/user/widget/online'
    import VueSticky from 'vue-sticky'

    export default {
        components: { Dock, ProfilePic, onlineUsers },
        directives: {
            'sticky': VueSticky,
        },
        name: 'navigation',
        data () {
            return {
                blurred: true,
	            w: window.innerWidth
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Navigation.vue